import {NgModule} from '@angular/core';
import {AgGridModule} from 'ag-grid-angular';
import {DangerousGoodsComponent} from './dangerous-goods.component';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [DangerousGoodsComponent],
    imports: [
        CollapseModule,
        AgGridModule,
        FontAwesomeModule
    ],
  exports: [DangerousGoodsComponent]
})
export class DangerousGoodsModule {
}
